import SingleChoiceField from './components/SingleChoiceField';
import TextField from './components/TextField';
import { FieldDiscriminator, FieldProps } from './types';

export const fields: {
  [key in FieldDiscriminator]: (props: FieldProps) => JSX.Element;
} = {
  textfield: TextField,
  singlechoicefield: SingleChoiceField,
};
